import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  data,
  json,
} from "@remix-run/node";
import { useActionData, useFetcher, useLoaderData } from "@remix-run/react";
import { hash } from "argon2";
import { $path } from "remix-routes";
import { RegisterForm } from "~/components/auth/RegisterForm";
import { authenticator } from "~/lib/services/auth.server";
import { commitSession, getSession } from "~/lib/services/session.server";
import {
  createUser,
  createVerificationToken,
  registerUserSchema,
} from "~/lib/services/user.service";
import { config } from "~/lib/utils/config.server";
import { getEnvs } from "~/lib/utils/env.server";
import { createLogger } from "~/lib/utils/logger.server";
import { sendMail } from "~/lib/utils/mail.server";

const logger = createLogger(import.meta.filename);

export async function loader({ request }: LoaderFunctionArgs) {
  await authenticator.isAuthenticated(request, {
    successRedirect: $path("/app"),
  });

  const session = await getSession(request.headers.get("cookie"));
  const error = session.get(authenticator.sessionErrorKey);

  if (error) {
    logger.debug(error, "Failed to register");
  }

  return data(
    {
      hasError: !!error,
      enableGithub: config.authentication.github.enabled,
    },
    { headers: { "Set-Cookie": await commitSession(session) } },
  );
}

export async function action({ request }: ActionFunctionArgs) {
  const { password, ...rest } = registerUserSchema.parse(
    await request.formData(),
  );

  const hashedPassword = await hash(password);

  const user = await createUser({
    ...rest,
    hashedPassword,
  });

  const token = await createVerificationToken(user.id);

  const verifyUrl = `${getEnvs().BASE_URL}${$path("/verify_token/:tokenId", { tokenId: token.token })}`;
  await sendMail(
    user.email,
    "AIFred: Account Verifizierung",
    `Bitte auf den nachfolgenden Link klicken: ${verifyUrl}`,
  );

  return json({ success: true });
  // try {
  //   return await authenticator.authenticate("user-pass", request, {
  //     successRedirect: "/dashboard",
  //     failureRedirect: "/register",
  //     throwOnError: true,
  //   });
  // } catch (error: unknown) {
  //   if (error instanceof Response) return error;
  //   logger.error(error, "Failed to authenticate");

  //   // throw error;
  // }
}

export default function Page() {
  // TODO maybe use error from useActionData()
  const { hasError, enableGithub } = useLoaderData<typeof loader>();
  const data = useActionData<typeof action>();
  const fetcher = useFetcher();

  return (
    <div className="flex h-full items-center justify-center">
      {data?.success && fetcher.state === "idle" ? (
        <div>Success</div>
      ) : (
        <RegisterForm
          className="m-2"
          enableGithub={enableGithub}
          hasError={hasError}
        />
      )}
    </div>
  );
}
